<template>
	<div class="border border-t-0 rounded-b p-2 theme-light:border-gray">
		<slot></slot>
	</div>
</template>
